export const itemElementStyle = {
  color: "#555",
  fontWeight: 400,
  fontSize: 14,
  textAlign: "justify",
};
